import * as api from '@apis/commission-rates';
import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import React from 'react';

interface SelectCommissionRateTemplateProps {
  selectedTemplateId?: string;
  onSelect?: (commissionRateId: string) => void;
  style?: any;
}

export const SelectCommissionRateTemplate: React.FC<SelectCommissionRateTemplateProps> = (props) => {
  const commissionRateTemplateQuery = useQuery({
    queryKey: [`select-search-commission-rate-templates`],
    queryFn: () => api.searchCommissionRateTemplates({ page: 0, size: 500 }),
  });

  const searchResult = commissionRateTemplateQuery.data?.data?.contents || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...props.style }}>
      <div>
        <Select
          placeholder="선택"
          value={props?.selectedTemplateId}
          style={{ width: '100%' }}
          onChange={(value) => {
            value;
            props.onSelect && props.onSelect(value);
          }}
          options={[
            ...searchResult.map((item) => {
              const labelText = `앱: ${item.channelCommissionRate?.app?.ratePercent}% 네이버: ${item.channelCommissionRate?.['naver-store']?.ratePercent}% 카카오: ${item.channelCommissionRate?.['kakao-reservation']?.ratePercent}% `;
              const label = (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  <div>{item.title}</div>
                  <div style={{ fontWeight: 'bold' }}>{labelText}</div>
                </div>
              );
              return {
                value: item._id,
                label: label,
              };
            }),
          ]}
        />
      </div>
    </div>
  );
};
